/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlCertificate = "/master/certificates";
const urlCertificateDeleteMultiple = "/master/certificates/delete-multiple";

const state = {
  certificates: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  async getListCertificate({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlCertificate}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_CERTIFICATES", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Create shift
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post(urlCertificate, payload);
  },

  /**
   * Update shift
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return await axios.put(`${urlCertificate}/${id}`, payload);
  },

  /**
   * Delete shift
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`${urlCertificate}/${id}`);
  },

  /**
   * delete multiple shift
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlCertificateDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_CERTIFICATES(state, data) {
    state.certificates = data;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
